// src/contexts/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { getSessionToken as initiateSessionAPI } from '../api/dressApi';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authError, setAuthError] = useState("");
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  const initiateSession = async () => {
    setIsAuthLoading(true);
    setAuthError("");
    try {
      const response = await initiateSessionAPI();
      if (response.success) {
        setIsAuthenticated(true);
      } else {
        throw new Error(response.message || "Session initiation failed at API level.");
      }
    } catch (err) {
      console.error("AuthProvider: Failed to initiate session:", err);
      setAuthError(String(err.message || "Could not initialize session. Please try refreshing."));
      setIsAuthenticated(false);
    } finally {
      setIsAuthLoading(false);
    }
  };

  useEffect(() => {
    initiateSession();
  }, []);

  const value = {
    isAuthenticated,
    authError,
    isAuthLoading,
    reInitiateSession: initiateSession,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};